import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

export const ReplaceWithIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} data-testid="replace-with">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2H14L20 8V20C20 21.1 19.1 22 18 22H14V18H17L12 12.5L7 18H10V22H5.99C4.89 22 4 21.1 4 20L4.01 4C4.01 2.9 4.9 2 6 2ZM13 3.5V9H18.5L13 3.5Z"
        fill="white"
      />
    </SvgIcon>
  );
};
